import { render } from "./experts.vue?vue&type=template&id=308a7ec9&scoped=true"
import script from "./experts.vue?vue&type=script&lang=js"
export * from "./experts.vue?vue&type=script&lang=js"

import "./experts.vue?vue&type=style&index=0&id=308a7ec9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308a7ec9"]])

export default __exports__